<template>
  <div class="px-3 pb-5">
    <b-row class="pt-5 pb-5 text-center"><h4><b>Please connect to the new LinkedIn App in order to share this post.</b></h4></b-row>
    <b-row class="py-3 justify-content-center">
      <b-btn :href="connectLinkedInURL" variant="linkedin">Connect
          LinkedIn</b-btn>
    </b-row>
  </div>
</template>

<script>
import qs from 'querystring';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    contentShareID: {
      type: String
    }
  },
  computed: {
    ...mapRoot([ 'origin', 'authServiceOrigin' ]),
    connectLinkedInURL() {
      return `${this.authServiceOrigin}/oauth2/linkedin?${qs.stringify({
        scope: 'r_liteprofile r_emailaddress w_member_social',
        version: 'v1',
        redirect: `${this.origin}${this.$route.path}?callback=connectLinkedInForPosting:${this.contentShareID}`
      })}`;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/content-share/ConnectLinkedIn.vue